(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/utils/constants.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/utils/constants.js');
"use strict";

setGlobal('svs.tickets.play.utils.constants', {
  PICK_PATH: '/valja/:ticketType',
  PLAY_PATH: '/spela/:ticketType/:wagerId',
  MY_GAMING_PATH: '/mina-spel/:wagerId',
  ANIMATIONS: {
    USP: {
      duration: 1.1
    },
    USP_BACKGROUND: {
      duration: 0.6
    }
  }
});

 })(window);